

import styles from './index.module.scss'
import styles2 from '../index.module.scss'
import changeIcon from '@assets/images/svgIcon/changeIcon.svg'
import { useState, useEffect, useRef, useContext, useMemo } from 'react'
import Iconfont from '@utils/Iconfont';
import ChangeShareMode from '../hooks/changeShareMode';
import EditNameModal from '../hooks/editNameModal';
import { AppContext } from '@utils/AppContext';
import eventBus from '@utils/eventBus';



const TopWrap = (props) => {
    const { globalUser, globalOrgInfo, globalBalance, globalFreeze } = useContext(AppContext);
    const editNameModalRef = useRef(null);
    const changeShareModeModalRef = useRef(null);

    const memberLevel = useMemo(() => {
        return (globalUser?.membership?.level && globalUser?.membership?.level != -100)  ? 
        globalUser?.membership?.level : 0
    }, [globalUser])

    // 是否是团队管成员
    const isTeamMember = useMemo(() => {
        return globalOrgInfo?.current?.role == 'member'
    }, [globalOrgInfo])

    // 是否是团队管理页面
    const isMemberPage = useMemo(() => {
        return props.type == 'member'
    }, [props.type])

    const isTransactionPage = useMemo(() => {
        return props.type == 'transaction'
    }, [props.type])

    // 剩余席位
    const remainingMembers = useMemo(() => {
        return globalOrgInfo?.current?.supportMembers - globalOrgInfo?.current?.currentMembers < 0 ? 0 :
            globalOrgInfo?.current?.supportMembers - globalOrgInfo?.current?.currentMembers
    }, [globalOrgInfo])

    return (
        <>
            {
                globalOrgInfo?.isPersonal ? <div className={styles2.topWrap}>
                    <div className={styles2.topLeft}>
                        <div className={styles2.topItem}>
                            <span>{globalUser?.membership?.balance}</span>
                            <span>可用虹豆</span>
                        </div>
                        <div className={styles2.topItem}>
                            <span>{globalFreeze}</span>
                            <span>冻结中虹豆</span>
                        </div>
                    </div>

                    <div className={styles2.topRight}>
                        {
                            memberLevel !== 0 && <p onClick={() => {
                                eventBus.emit('OPEN_DATA_PACKAGE')
                            }}>虹豆加油包</p>
                        }
                        <span onClick={() => {
                            eventBus.emit('recharge')
                        }}>升级会员</span>
                    </div>
                </div> : <div className={styles2.topWrap}>
                    <div className={styles2.topLeft}>
                        <div className={styles2.topItemTeam}>
                            <div className={styles2.topTeamlogo}>{globalOrgInfo?.current?.orgName?.charAt(0)}</div>
                            <div className={styles2.TopTeamWarp}>
                                <p onClick={() => editNameModalRef.current.setEditNameVisible(true)}>
                                    {globalOrgInfo?.current?.orgName}
                                    {!isTeamMember && <Iconfont className={styles2.Icon} type="icon-editOutlined" />}
                                </p>
                                <p>
                                    <span>成员人数</span>
                                    <span>{globalOrgInfo?.current?.currentMembers}</span>
                                    <span>剩余席位</span>
                                    <span>{remainingMembers}</span>
                                </p>
                            </div>
                        </div>
                        <div className={styles2.topItem}>
                            <span>{globalUser?.membership?.balance}</span>
                            <span>可用虹豆</span>
                        </div>
                        <div className={styles2.topItem}>
                            <span>{globalFreeze}</span>
                            <span>冻结中虹豆</span>
                        </div>
                    </div>
                    {
                        !isTeamMember && <>
                            <div className={styles2.topRight}>
                                {
                                    memberLevel !== 0 && <p onClick={() => {
                                        eventBus.emit('OPEN_DATA_PACKAGE')
                                    }}>虹豆加油包</p>
                                }
                                {
                                    isMemberPage ? (
                                        memberLevel == 0 ? <span onClick={() => { eventBus.emit('recharge') }}>开通会员</span> :
                                            memberLevel == 5 ? <span onClick={() => { eventBus.emit('recharge') }}>升级套餐</span> :
                                                memberLevel == 6 ? <span onClick={() => { eventBus.emit('OPEN_DATA_SEAT') }}>增加席位</span> :
                                                    <span onClick={() => { eventBus.emit('recharge') }}>续购套餐</span>
                                    ) : (
                                        memberLevel == 0 ? <span onClick={() => { eventBus.emit('recharge') }}>开通会员</span> :
                                            (memberLevel == 1 || memberLevel == 2 || memberLevel == 3 || memberLevel == 4) ? <span onClick={() => { eventBus.emit('recharge') }}>升级套餐</span> :
                                                <span onClick={() => { eventBus.emit('recharge') }}>续购套餐</span>
                                    )
                                }

                            </div>

                            {
                                (memberLevel !== 0 && isTransactionPage) && <span
                                    onClick={() => changeShareModeModalRef.current.setOpen(true)}
                                    className={styles2.changeType}>
                                    切换虹豆共享模式（{globalOrgInfo?.current?.powerAllocateMode ? '管理员分配' : '自由共享'}） <img src={changeIcon} alt="" />
                                </span>
                            }

                        </>
                    }
                </div>
            }
            <EditNameModal ref={editNameModalRef} />
            <ChangeShareMode ref={changeShareModeModalRef} />
        </>

    )
}

export default TopWrap